import { useUserStore } from "../store";
const useUserId = () => useUserStore((state) => state?.user?.id);

export default useUserId;
